import { ButtonBase, Typography } from '@mui/material';
import { CardLinkFrameSx, CardLinkNameSx } from '@/components/content/HelpCenter/styles/cardLink';

export const CardLink = ({
	name,
	icon,
	isActive,
	onClick,
}: {
	name: string;
	icon: React.ReactNode;
	isActive: boolean;
	onClick: () => void;
}) => (
	<ButtonBase
		onClick={onClick}
		sx={{
			...CardLinkFrameSx,
			border: isActive ? '2px solid #011688' : '1px solid #C9C9C9',
			backgroundColor: isActive ? '#F0F7FF' : '#fff',
			'& svg': {
				stroke: isActive ? '#011688' : undefined,
				fill: isActive ? '#011688' : undefined,
			},
			'& p': {
				color: isActive ? '#011688' : '#2C2C2C',
			},
		}}
	>
		{icon}
		<Typography component="p" sx={CardLinkNameSx}>
			{name}
		</Typography>
	</ButtonBase>
);
